/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Stage_DescriptionInputs */



/**
* | output |
* | --- |
* | "Put cards in front of an audience: a full-screen show for window capture, or a transparent browser source you paste into OBS." |
*
* @param {Help_Article_Stage_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_stage_description = /** @type {((inputs?: Help_Article_Stage_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Stage_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeig Karten vor Publikum: eine Vollbild-Show für die Fensteraufnahme oder eine transparente Browserquelle, die du in OBS einfügst.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Montrez des cartes à un public : un affichage plein écran pour la capture de fenêtre, ou une source navigateur transparente à coller dans OBS.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("把卡牌展示给观众：可用于窗口捕获的全屏视图，或可粘贴进 OBS 的透明浏览器源。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("把卡牌呈現在觀眾眼前：供視窗擷取的全螢幕展示，或貼進 OBS 的透明瀏覽器來源。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("관객에게 카드를 보여 주세요. 창 캡처용 전체 화면 화면이나 OBS에 붙여 넣는 투명 브라우저 소스를 쓸 수 있습니다.")
	return /** @type {LocalizedString} */ ("Put cards in front of an audience: a full-screen show for window capture, or a transparent browser source you paste into OBS.")
});